<template>
  <div width="100%" v-if="haveShow" :class="{waterParam:swiths.length===0&&sensors.length === 0}">
    <video  width="100%" height="100%"  :id="videoId" class="video-js vjs-default-skin" muted controls preload="auto" poster="../../assets/video_def_2.png">
      <source :src="url" type="application/x-mpegURL">
    </video>
    <img v-if="showLogo" style="position:absolute;bottom:20px;right:20px;width:80px;height:40px;" src="../../assets/nxinlogo.png" alt="">
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'
import { mapState } from 'vuex'
import equipmentSocketModule from '../../store/modules/equipmentSocket'
export default {
  name: 'LiveVideo',
  data () {
    return {
      videoId: `video${this.$props.index}`,
      // showLogo: false,
      instance: null,
      waterParam: false,
      showLogo: false,
      haveShow: true
    }
  },
  props: {
    url: String,
    index: Number
    // showLogo: false
  },
  mounted () {
    // if (this.swiths.length === 0 && this.sensors.length === 0) {
    //   this.waterParam = true
    // }

    let me = this
    this.instance = videojs(this.videoId, {
      bigPlayButton: false,
      textTrackDisplay: false,
      posterImage: true,
      errorDisplay: false,
      controlBar: true
    }, function () {
      this.play().then((e) => {
        me.showLogo = true
        me.$emit('play', me.$props.index)
      }).catch((e) => {
        me.haveShow = false
        me.instance.dispose()
        me.$emit('error', me.$props.index)
      })
    })
  },
  computed: {
    ...mapState(equipmentSocketModule, ['swiths', 'sensors'])
  },
  beforeDestroy () {
    if (this.instance) {
      this.instance.dispose()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .time-monitor
    @media screen and (min-width: 1800px) and (max-width: 1920px) {
      .wrap{
        height 710px !important
      }
    }
    @media screen and (min-width: 1365px) and (max-width: 1400px) {
      .wrap{
        height 406px !important
      }
    }
    display: flex;
    flex 1
    flex-wrap :wrap;
    flex-direction column
    // height 100%
    margin-right 8px
    // background #619179;
    .up
      margin-right 40px
      color blue
    .wrap
      display flex
      flex-wrap wrap
      justify-content center
      justify-content flex-start
      // max-height 576px;
      flex 1
      height 100%
      overflow auto
      >div
        position relative
        flex 0 0 33.33%
        height 50%
      .video-js
        // flex 0 0 33.33%
        // height 50%
        width 100%;
        height 100%;
      .video-js .vjs-tech
        height: 100%;
        padding:3px;
      video
        width 100%
        // height 100%
        object-fit fill   // 自动填充慢父div的大小 不受默认比列所影响
      .waterParam  video
        object-fit fill !important
</style>
